import {
  EasyTimePickerComposablesData,
  EasyTimePickerDropdownEmits,
  EasyTimePickerDropdownProps,
  EasyTimePickerInputEmits,
  EasyTimePickerInputProps,
  InputRef,
  TimeParts,
} from "../../types/easyTimePicker";

export const useGetSetHelpers = (
  props: EasyTimePickerInputProps | EasyTimePickerDropdownProps,
  emit: EasyTimePickerInputEmits | EasyTimePickerDropdownEmits,
  data?: EasyTimePickerComposablesData
) => {
  const getInputRef = (part: TimeParts): InputRef | undefined => {
    if (!data) return;
    if (part === TimeParts.Hours) return data.hoursInput;
    if (part === TimeParts.Minutes) return data.minutesInput;
    return data.meridiemInput;
  };

  const getInputValue = (part: TimeParts): string => {
    if (part === TimeParts.Hours) return props.hoursValue;
    if (part === TimeParts.Minutes) return props.minutesValue;
    return props.meridiemValue;
  };

  const setInputValue = (part: TimeParts, newValue: string): void => {
    if (part === TimeParts.Hours) emit("update:hoursValue", newValue);
    if (part === TimeParts.Minutes) emit("update:minutesValue", newValue);
    if (part === TimeParts.Meridiem) emit("update:meridiemValue", newValue);
    emit("change");
  };

  return {
    getInputRef,
    getInputValue,
    setInputValue,
  };
};
